import { memo, type FC } from "react";
import { AlertTriangleIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface SystemNoticeMessagePart {
  type: "system-notice";
  message: string;
}

interface SystemNoticeProps {
  part: SystemNoticeMessagePart;
}

const SystemNoticeImpl: FC<SystemNoticeProps> = ({ part }) => {
  return (
    <div
      className={cn(
        "my-1 flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800",
        "dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-300",
      )}
    >
      <AlertTriangleIcon className="size-3 shrink-0" />
      <span>{part.message}</span>
    </div>
  );
};

export const SystemNotice = memo(SystemNoticeImpl);
